import Vue from 'vue';
import App from '@/app/app.vue';
import router from '@/app/routes/router';
import routeGuard from '@/app/routes/route-guard.js';
import store from '@/app/stores/store';

// directives
import Directives from '@/app/directives/directives';
import ScrollAnimation from '@/app/directives/scrollanimation';

// filters
import Filters from '@/app/filters/filters';
import Vue2Filters from 'vue2-filters';

// styles
import './app/styles/main.scss';
import './app/styles/img.css';
import 'vue2-datepicker/index.css';
import 'vue-select/dist/vue-select.css';

// third parties
import '../node_modules/jquery/src/jquery.js'
import '../node_modules/popper.js/dist/popper.min.js';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import * as VueGoogleMaps from 'vue2-google-maps';
import Vuelidate from 'vuelidate';
import VueGtag from "vue-gtag";
import SweetAlert from 'vue-sweetalert2';
import Notifications from 'vue-notification';
import velocity from 'velocity-animate';
import vSelect from 'vue-select';
import InfiniteLoading from 'vue-infinite-loading';
import LightTimeline from 'vue-light-timeline';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import VueLazyload from 'vue-lazyload'

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
library.add(fas, far, fab);
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// use
Vue.directive('scrollanimation', ScrollAnimation);
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA_KEY
  }
}, router);
Vue.use(Filters);
Vue.use(Vue2Filters);
Vue.use(Directives);
Vue.use(SweetAlert);
Vue.use(Notifications, { velocity });
Vue.use(Vuelidate);
Vue.use(InfiniteLoading, {
  // Options {@link https://peachscript.github.io/vue-infinite-loading/api/#options}
  slots: {
    noMore: 'End of Content',
    noResults: 'End of Content',
    error: 'Unable to fetch content.'
  }
});
Vue.use(LightTimeline);
Vue.config.productionTip = false;
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_KEY,
    libraries: 'places,drawing'
  },
  installComponents: true
});

Vue.use(VueLazyload, {
  observer: true,
})

// Component
Vue.component('v-select', vSelect);
Vue.component('vue-fontawesome', FontAwesomeIcon)
// access window object on vue templates ($window)
Vue.prototype.$window = window;

// register route guard
routeGuard();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

